import { ReactElement } from "react";
import { Link, Outlet } from "react-router-dom";

import CompanyLogo from "../assets/media/logo.svg";

import MainContainer from "./main-container";

export default function UnauthLayout(): ReactElement {
  return (
    <div className="flex min-h-screen min-w-screen bg-companyLightGrey overflow-hidden">
      <MainContainer>
        <div className="mb-30 flex w-full flex-row justify-between pl-[45px]">
          <div className="flex items-center">
            <div className="pt-5 pb-15 pr-15 border-r border-neutral-400 relative">
              <Link to="/">
                <img
                  className="max-h-full"
                  src={CompanyLogo}
                  alt="Company Logo"
                />
              </Link>
              <span className="text-[10px] absolute right-16 bottom-5 font-bold text-gray-400">
                METAHUB
              </span>
            </div>
          </div>
        </div>
        <Outlet />
      </MainContainer>
    </div>
  );
}
